import { Card, Flex } from "antd";

import {
  DeficientProjects,
  ProjectsByStage,
  ProjectsTimeTrackingSummary,
} from "projects/components";
import {
  IDeficientProject,
  IProjectByStage,
  IProjectTimeTrackingSummary,
} from "projects/models";
import variables from "../../../../../_variables.scss";

type Props = {
  loading?: boolean;
  deficientProjects?: IDeficientProject[];
  projectsByStage?: IProjectByStage[];
  projectsTimeTrackingSummary?: IProjectTimeTrackingSummary[];
};

export const ProgramManagerDashboardProjectCard = ({
  loading,
  deficientProjects,
  projectsByStage,
  projectsTimeTrackingSummary,
}: Props) => {
  return (
    <Card
      loading={loading}
      bordered={false}
      data-testid='programManagerDashboardProjectCard'
    >
      <Flex vertical gap={variables.gap}>
        <h1>Projects</h1>
        <Flex gap={variables.gap}>
          <ProjectsByStage
            projectsByStage={projectsByStage ?? []}
            height={variables.defaultComponentHeight}
          />
          <ProjectsTimeTrackingSummary projectsTimeTrackingSummary={projectsTimeTrackingSummary ?? []} />
        </Flex>
        <DeficientProjects deficientProjects={deficientProjects ?? []} />
      </Flex>
    </Card>
  );
};
